import { useMutation, useQueryClient } from '@tanstack/react-query';
import formatHistoryDataWs from '../../../utils/formatHistoryDataWs';

const useAddReport = ({
    clientId,
    pptReporting,
}: {
    clientId: number;
    pptReporting: boolean;
}) => {
    const queryClient = useQueryClient();

    const addReport = async (data: any) => {
        let newFormattedHistory = data;
        if (pptReporting) {
            newFormattedHistory = data.map((d: any) => formatHistoryDataWs(d));
        }
        return newFormattedHistory;
    };

    const mutation = useMutation({
        mutationFn: addReport,
        onSuccess: data => {
            queryClient.setQueryData(
                ['historyData', clientId, pptReporting],
                (oldData: any) => {
                    // Ensure oldData is an array, default to empty array if not
                    const existingData = Array.isArray(oldData) ? oldData : [];
                    return [...data, ...existingData];
                },
            );
        },
    });

    return mutation;
};

export default useAddReport;
